import { TrendingUp, Pause, ImageIcon } from "lucide-react";

interface GameNFTMiniCardProps {
  nft: {
    id: string;
    name: string;
    image_url: string | null;
    current_price: number;
    sales_count: number;
    owner_name?: string;
    owner_id: string;
    is_listed?: boolean;
  };
  playerId: string;
  onBuy: () => void;
}

export function GameNFTMiniCard({ nft, playerId, onBuy }: GameNFTMiniCardProps) {
  const isOwner = nft.owner_id === playerId;
  const isPaused = nft.is_listed === false;

  return (
    <div className={`min-w-[140px] max-w-[140px] rounded-xl border bg-black/70 backdrop-blur-sm overflow-hidden flex-shrink-0 snap-start card-game-glow transition-all ${
      isPaused ? "border-yellow-500/40" : "border-purple-500/30"
    }`}>
      <div className="aspect-square bg-gray-900 relative overflow-hidden">
        {nft.image_url ? (
          <img
            src={nft.image_url}
            alt={nft.name}
            className={`w-full h-full object-cover ${isPaused ? "opacity-60 grayscale" : ""}`}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              const img = e.currentTarget;
              img.style.display = "none";
              const fb = img.nextElementSibling as HTMLElement | null;
              if (fb) fb.style.display = "flex";
            }}
          />
        ) : null}
        <div
          className="w-full h-full items-center justify-center bg-gradient-to-br from-purple-900/40 via-black to-pink-900/30"
          style={{ display: nft.image_url ? "none" : "flex" }}
        >
          <ImageIcon className="w-8 h-8 text-purple-400/60" />
        </div>
        {nft.sales_count > 0 && !isPaused && (
          <div className="absolute top-1 right-1 bg-black/80 rounded-full px-1.5 py-0.5 flex items-center gap-0.5 border border-pink-500/40">
            <TrendingUp className="w-2.5 h-2.5 text-pink-400" />
            <span className="text-[10px] font-bold text-white">{nft.sales_count}</span>
          </div>
        )}
        {isPaused && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-yellow-500/90 text-black text-[10px] font-extrabold px-2 py-1 rounded-md flex items-center gap-1 shadow-lg">
              <Pause className="w-3 h-3" fill="currentColor" />
              PAUSED
            </div>
          </div>
        )}
      </div>
      <div className="p-2 space-y-1">
        <p className="font-bold text-xs truncate text-white">{nft.name}</p>
        <p className="text-[10px] text-gray-500 truncate">{nft.owner_name || "Unknown"}</p>
        <div className="flex items-center justify-between gap-1">
          <span
            className={`text-sm font-extrabold ${isPaused ? "text-gray-500" : "text-game-cyan"}`}
            style={!isPaused ? { textShadow: '0 0 8px rgba(6, 182, 212, 0.6)' } : undefined}
          >
            ${Number(nft.current_price).toFixed(2)}
          </span>
          {isPaused ? (
            <span className="text-[10px] text-yellow-400 font-bold">Paused</span>
          ) : !isOwner ? (
            <button
              onClick={onBuy}
              className="text-[10px] font-bold px-2 py-0.5 rounded btn-game-neon"
            >
              Buy
            </button>
          ) : (
            <span className="text-[10px] text-game-pink font-semibold">Yours</span>
          )}
        </div>
      </div>
    </div>
  );
}
